import React, { useState, useEffect } from "react";
import { Search, ShoppingCart, Menu } from "lucide-react";
import Logo from "../assets/images/logo.png";
import DesktopBanner from "../assets/images/Banner.png";
import MobileBanner from "../assets/images/Home-Mobilebanner.jpg";
import PupTreatsInfoSection from "./PupTreatsInfoSection";
import Reviews from "./Reviews";
import Footer from "./Footer";
import InstagramFeed from "./InstagramFeed";

export default function StickyNavbarLayout() {
  

  return (
    <div style={{ fontFamily: "Arial, sans-serif", overflowX: "hidden" }}>
      {/* Banner Section - Starts from absolute top */}
      <div
        style={{
          position: "relative",
          width: "100%",
          height: "800px",
          overflow: "hidden",
        }}
      >
        <img
          src={DesktopBanner}
          alt="Banner"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            objectPosition: "center",
          }}
          className="desktop-banner"
        />

         <img
          src={MobileBanner}
          alt="Banner"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            objectPosition: "center",
          }}
          className="mobile-banner"
        />

        <style>{`
            @media (max-width: 768px) {
              .desktop-banner {
                display: none !important;
              }
              .mobile-banner {
                display: block !important;
              }
            }
          `}</style>
      </div>
      <PupTreatsInfoSection />
      <Reviews />
      <InstagramFeed />
    </div>
  );
}
